import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    getProfile,
    updateProfile,
    uploadProfileImage,
    deleteProfileImage,
    ProfileData
} from '../firebase/profileService';

// Query keys
export const profileKeys = {
    all: ['profile'] as const,
    detail: () => [...profileKeys.all, 'detail'] as const,
};

// Hooks
export const useProfileQuery = () => {
    return useQuery({
        queryKey: profileKeys.detail(),
        queryFn: getProfile,
    });
};

export const useUpdateProfileMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: Partial<ProfileData>) => updateProfile(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: profileKeys.detail() });
        },
    });
};

export const useUploadProfileImageMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ file, progressCallback }: {
            file: File;
            progressCallback?: (progress: number) => void
        }) => uploadProfileImage(file, progressCallback),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: profileKeys.detail() });
        },
    });
};

export const useDeleteProfileImageMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (imageUrl: string) => deleteProfileImage(imageUrl),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: profileKeys.detail() });
        },
    });
}; 